'use es6';

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { ModalTransitionContextProvider } from '../../context/ModalTransitionContext';
var InnerMeasure = styled.span.attrs({
  'aria-hidden': true
}).withConfig({
  displayName: "HiddenMeasure__InnerMeasure",
  componentId: "sc-6v8zhz-0"
})(["overflow:hidden;position:absolute;left:0;max-width:100%;visibility:hidden;pointer-events:none;"]); // We want to force popovers to stay closed, so we use ModalTransitionContext to tell popovers that
// they're in a transitioning modal. Weird but effective!

var hidePopoversContextValue = {
  transitioning: true
};
var HiddenMeasure = forwardRef(function (props, ref) {
  return React.createElement(ModalTransitionContextProvider, {
    value: hidePopoversContextValue
  }, React.createElement(InnerMeasure, Object.assign({}, props, {
    ref: ref
  })));
});
export default HiddenMeasure;